import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import * as IoIcons from "react-icons/io";
import {
  obtenerNumeroTrabajadores,
  obtenerRepresentanteLegal,
  trabajadoresPorInstitucion,
} from "../../Services/Rest";
import CreaTrabajadores from "../Modals/crear/CreaTrabajadores";
import { useParams } from "react-router-dom";

const cookie = new Cookies();

const grupos = ["1", "2", "3"];
const TrabajadoresEvaluador = (props) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "codigoPerfil",
        header: "Codigo Perfil",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },
      {
        accessorKey: "descripcionPerfil",
        header: "Descripción Perfil",
        filterVariant: "text",
        enableEditing: false, //disable editing on this column
      },

      {
        accessorKey: "descripcionOtros",
        header: "Descripción Otros",
        filterVariant: "text",
        //disable editing on this column
      },
      {
        accessorKey: "asistenciales",
        header: "Asistenciales",
        filterVariant: "text",
      },
      {
        accessorKey: "administrativas",
        header: "Administrativas",
        filterVariant: "text",
      },
      {
        accessorKey: "total1",
        header: "Total",
        filterVariant: "text",
      },

      {
        accessorKey: "asistencialesAdministrativas",
        header: "Asistenciales Administrativas",
        filterVariant: "text",
      },
      {
        accessorKey: "planta",
        header: "planta",
        filterVariant: "text",
      },
      {
        accessorKey: "prestacionServicios",
        header: "Prestacion Servicios",
        filterVariant: "text",
      },
      {
        accessorKey: "terceros",
        header: "Terceros",
        filterVariant: "text",
      },
      {
        accessorKey: "trabajadoresServicios",
        header: "Trabajadores Servicios",
        filterVariant: "text",
      },
      {
        accessorKey: "otros",
        header: "Otros",
        filterVariant: "text",
      },
      {
        accessorKey: "total2",
        header: "Total",
        filterVariant: "text",
      },
      {
        accessorKey: "nombreInstitucion",
        header: "Institución",
        filterVariant: "text",
      },
      {
        accessorKey: "fechaCorte",
        header: "Fecha Corte",
        filterVariant: "text",
      },
    ],
    [],
  );
  let { id } = useParams();
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerSolicitudTrabajadoresPorInstitucionId?InstitucionId=" +
        id,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [tableData, setTableData] = useState(() => list1);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaRepresentanteLegal?Id=" +
        values.id,
      data: values,
    })
      .then((Response) => {
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });
    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
  };

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Información de los Trabajadores
                </h6>

                <div className="row"></div>
                <hr />

                <hr />
                <MaterialReactTable
                  columns={columns}
                  data={list1}
                  initialState={{ showColumnFilters: true }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrabajadoresEvaluador;
